import React, { useState, useEffect } from 'react';
import { Checkbox, Space } from 'antd';
import ConfirmationModal from '../../CustomComponents/ConfirmationModal';
import {
  ColumnSettingsContainer,
  ColumnCheckboxItem,
  ResetButton
} from '../JobList/styledComponents';

export const BILLER_DEFAULT_COLUMNS = {
  jobId: true,
  author: true,
  patientName: true,
  jobNumber: true,
  submissionTime: false,
  effectiveDate: false,
  facilityName: false,
  workType: true,
  dictationTemplate: true,
  assignedBiller: false,
  biller: false,
  currentAssignee: false,
  rejectedByReviewerTime: false,
  billedTime: false,
  status: false,
  submissionToReviewerLevel1Time: false,
  emrSubmissionTime: false,
  admissionDate: false,
  mrn: false,
  dischargeDate: false,
  primaryCarePhysician: false,
  actions: true
};

const columnConfig = [
  { key: 'jobId', label: 'Job ID', mandatory: true },
  { key: 'author', label: 'Author', mandatory: false },
  { key: 'patientName', label: 'Patient Name', mandatory: false },
  { key: 'jobNumber', label: 'Job Number', mandatory: false },
  { key: 'submissionTime', label: 'Submitted Time', mandatory: false },
  { key: 'effectiveDate', label: 'Encounter Date', mandatory: false },
  { key: 'facilityName', label: 'Facility', mandatory: false },
  { key: 'currentAssignee', label: 'Current Assignee', mandatory: false },
  { key: 'assignedBiller', label: 'Assigned Biller', mandatory: false },
  { key: 'biller', label: 'Claimed Biller', mandatory: false },
  { key: 'workType', label: 'Work Type', mandatory: false },
  { key: 'dictationTemplate', label: 'Dictation Template', mandatory: false },
  { key: 'submissionToReviewerLevel1Time', label: 'Submission Time to Reviewer', mandatory: false },
  { key: 'rejectedByReviewerTime', label: 'Reviewer Rejected Time', mandatory: false },
  { key: 'billedTime', label: 'Billed Time', mandatory: false },
  { key: 'emrSubmissionTime', label: 'EMR Submission Time', mandatory: false },
  { key: 'status', label: 'Status', mandatory: false },
  { key: 'admissionDate', label: 'Admission Date', mandatory: false },
  { key: 'mrn', label: 'MRN', mandatory: false },
  { key: 'dischargeDate', label: 'Discharge Date', mandatory: false },
  { key: 'primaryCarePhysician', label: 'Primary Care Physician', mandatory: false }
];

const BillerColumnSettingsModal = ({
  visible,
  onCancel,
  onSave,
  visibleColumns
}) => {
  const [tempColumns, setTempColumns] = useState(visibleColumns);

  useEffect(() => {
    setTempColumns(visibleColumns);
  }, [visibleColumns]);

  const handleToggle = key => {
    const column = columnConfig.find(c => c.key === key);
    if (!column?.mandatory) {
      setTempColumns({ ...tempColumns, [key]: !tempColumns[key] });
    }
  };

  const handleCancel = () => {
    setTempColumns(visibleColumns);
    onCancel();
  };

  const handleSave = () => {
    onSave(tempColumns);
    onCancel();
  };

  const handleReset = () => {
    setTempColumns({ ...BILLER_DEFAULT_COLUMNS });
  };

  return (
    <ConfirmationModal
      visible={visible}
      onCancel={handleCancel}
      onOk={handleSave}
      header='Customize Columns'
      confirmation={true}
      antdModalProps={{ centered: true, width: 450, closable: false }}
    >
      {/* Kept above the scrollable list so it's reachable without scrolling */}
      <ResetButton onClick={handleReset}>Reset to Default</ResetButton>
      <ColumnSettingsContainer>
        <Space direction='vertical' size='middle' style={{ width: '100%' }}>
          {columnConfig.map(column => (
            <ColumnCheckboxItem key={column.key}>
              <Checkbox
                checked={tempColumns[column.key]}
                onChange={() => handleToggle(column.key)}
                disabled={column.mandatory}
              >
                {column.label}
                {column.mandatory && (
                  <span style={{ color: '#999' }}> (Required)</span>
                )}
              </Checkbox>
            </ColumnCheckboxItem>
          ))}
        </Space>
      </ColumnSettingsContainer>
    </ConfirmationModal>
  );
};

export default BillerColumnSettingsModal;
